import { validateGridSearch } from "@/components/composite/data-grid";
import { createFileRoute } from "@tanstack/react-router";
import { StylesPage } from "./-styles/styles.page";

export const Route = createFileRoute("/content/styles/")({
  validateSearch: validateGridSearch,
  component: StylesPage,
});
